<template>
    <div class="user-directions-button">
        <!-- Named by the visible slot label when one is passed (Global/actions),
             otherwise by aria-label. -->
        <a
            :href="`https://www.google.com/maps/search/?api=1&query=${address}`"
            target="_blank"
            rel="noopener"
            :aria-label="$slots.default ? undefined : 'Directions'"
            @click="trackDirectionsOpened">
            <SvgsDirections />
            <slot />
        </a>
    </div>
</template>

<script setup>
    const props = defineProps({
        item: {
            type: Object,
            required: true,
        },
    });
    const { item } = toRefs(props);
    // Street address plus city and state; a bare street address sends Google
    // Maps to whichever "111 W Washington" it likes best.
    const address = computed(() => encodeURIComponent(directionsQuery(item?.value?.fields)));

    function trackDirectionsOpened() {
        if (!item?.value?.id) return;
        const { track } = useAnalytics();
        track('directions_opened', { site_id: item.value.id, site_name: item.value.fields?.['Site'] || '', mode: 'default' });
    }
</script>

<style lang="scss" scoped>
    .user-directions-button {
        a {
            display: inline-block;
        }
    }
</style>
